import axios, {AxiosRequestConfig} from "axios";
import {api_host} from "../utils/constants";
import {configDefault} from "./post";

const Put = (url: string, data: any, cfg?: AxiosRequestConfig) =>
    axios.put(api_host + '/' + url, data, {...configDefault(), ...cfg});

export default Put;